<template>
  <div class="form">
    <div class="form__header">
      <h3>{{ data.option ? 'Редактировать' : 'Создать' }} вариант</h3>
    </div>

    <div class="form__body">
      <p class="form__field logo">
        <span>Картинка: </span>
        <ImageUpload ref="upload" />
      </p>     

      <p class="form__field">
        <span>Описание: </span>
        <textarea 
          v-model="formData.description" 
          rows="3"
          class="required"
          :class="{
            valid: formData.description,
            invalid: !formData.description,
          }"
        ></textarea>
      </p>

      <Input 
        class="form__field"
        v-model="formData.answer" 
        label="Ответ" 
        type="text" 
        id="answer" 
        :required="true"
      />
    </div>

    <div class="form__footer">
      <SubmitButton @submit="sendForm" :isValid="isValid" />
    </div>
  </div>
</template>

<script>
import { form_mix } from '../../../mixins/form_mix'
import { levels } from './levels'
import { mapGetters } from 'vuex'
import ImageUpload from '../../../other/ImageUpload.vue'
export default {
  mixins: [ form_mix ],
  components: { ImageUpload },
  inject: ['http', 'user', 'contest_id'],
  props: ['data'],
  data() {
    return {
      levels,
      formData: {
        trainer_id: null,
        level: '',
        answer: '',
        description: '',
        contest_id: this.contest_id,
        has_image: 0
      }, 
      requiredKeys: ['answer', 'level', 'description']
    }
  },
  computed: {
    ...mapGetters({
      allStudents: 'teacher/students'
    })
  },
  methods: {    
    sendForm() {
      let data = new FormData()
      let path = this.data.option ? 'onUpdateMatriusTask' : 'onCreateMatriusTask'
      let file

      if (!this.data.option) {
        file = this.$refs.upload.file ? this.$refs.upload.file : null
      } else {
        file = this.$refs.upload.file ? this.$refs.upload.file : this.data.option.file
        data.append('id', this.formData.id)        
      }      
      data.append('has_image', this.formData.has_image)
      data.append('file', file)
      data.append('description', this.formData.description)
      data.append('answer', this.formData.answer)
      data.append('level', this.formData.level)
      // data.append('trainer_id', this.formData.trainer_id)
      data.append('parent_id', this.formData.parent_id)
      data.append('contest_id', this.contest_id)

      this.http.post(path, data).then(res => {
        let message = this.data ? 'Команда обновлена' : 'Команда создана'
        this.$emit('close-popup')
        this.$emit('add-task-option', res.data)
        console.log(res.data)
        
        swal('Успешно!', message, 'success')
      })
    }
  },
  mounted() {
    if (this.data.option) {
      this.formData = Object.assign({}, this.data.option)

      this.$refs.upload.preview = this.data.option.image
    } else {
      this.formData.parent_id = this.data.block.id
      this.formData.level = this.data.block.level
    }
  }
}
</script>

